// 📄 pages/Proyectos/HerramientasHome.tsx
// Índice de las herramientas transversales del proyecto (no dependen de
// una solución en particular) — vive en /proyecto/:projectId/herramientas y
// se accede desde la tarjeta "Herramientas" en ProjectSolutionsHome.tsx.
//
// HERRAMIENTAS_ITEMS (menuConfig.tsx) es la única fuente: sidebar y este
// grid siempre muestran exactamente los mismos ítems.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext.tsx';
import { HERRAMIENTAS_ITEMS, IconoDe, segunModulos } from '../Dashboard/menuConfig.tsx';
import { esProyectoSap } from './modulosConfig.ts';
import HomeCard from '../../components/common/HomeCard.tsx';
import { useFavorites } from '../../hooks/useFavorites.ts';

export default function HerramientasHome() {
  const { project, projectId, esCliente } = useProject();
  const navigate = useNavigate();
  const { isFavorite, toggleFavorite } = useFavorites(projectId);

  // Mismo criterio que itemsVisibles() en ProjectSidebar.tsx: un item
  // soloConsultor desaparece por completo para el rol "cliente".
  const visibles = segunModulos(HERRAMIENTAS_ITEMS, esProyectoSap(project)).filter((item) => !item.soloConsultor || !esCliente);

  return (
    <div className="space-y-6">
      <p className="text-gray-400">Herramientas disponibles para este proyecto:</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {visibles.map((item) => (
          <HomeCard
            key={item.id}
            icon={<IconoDe icon={item.icon} size={32} />}
            label={item.label}
            tagline={item.tagline || ''}
            onClick={() => navigate(`/proyecto/${projectId}/${item.id}`)}
            isFavorite={isFavorite('tool', item.id)}
            onToggleFavorite={() => toggleFavorite('tool', item.id)}
          />
        ))}
      </div>
    </div>
  );
}
